import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reshape/definition"
import {ImageOpReshapeHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/reshape/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeReshape"}

@registerImageOpNode
export class ImageOpNodeReshape extends BasicSpecializingImageOpNode<typeof definition, ImageOpReshapeHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpReshapeHal, parameters)
    }
}
